module.exports = __webpack_public_path__ + "static/img/about.d1e8478.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/about.png
// module id = FhzR
// module chunks = 4